import styles from "./PartnersComponent.module.css";
import Marquee from "react-fast-marquee";

const PartnersComponent = () => {
  return (
    <div >
      <Marquee style={{width:'1588px !important',minwidth:'!important'}} className={styles.groupParent16} pauseOnHover={true}>
      <img className={styles.frameChild13} alt="bankBaroda" src="/bob.svg" />
      <img className={styles.frameChild14} alt="worldBank" src="/wb.svg" />
      {/* <div className={styles.clipPathGroupParent}>
        <img
          className={styles.clipPathGroup}
          alt=""
          src="/clip-path-group.svg"
        />
        <img className={styles.groupChild10} alt="" src="/group-369.svg" />
        <img className={styles.groupChild11} alt="" src="/group-368.svg" />
        <div className={styles.aGovernmentUndertaking}>
          (A Government Undertaking)
        </div>
      </div> */}
      {/* <div className={styles.theSataraDccBankLtdParent}>
        <b className={styles.theSataraDcc}>THE SATARA DCC BANK LTD.</b>
        <img
          className={styles.unnamedRemovebgPreview11}
          alt=""
          src="/unnamedremovebgpreview-1-1@2x.png"
        />
      </div> */}
      <img className={styles.frameChild80} alt="masterCard" src="/masterc.svg" />
      <img className={styles.frameChild81} alt="mscBank" src="/msc.svg" />
      <img className={styles.frameChild82} alt="mscw" src="/mswc.svg" />
      {/* <img className={styles.frameChild83} alt="sataraBank" src="/sataraBank.png" /> */}
      <img className={styles.frameChild84} alt="tvs" src="/tvs.svg" />
      <img className={styles.frameChild85} alt="unionBank" src="/union.svg" />
      </Marquee>
    </div>
  );
};
// const partners = [
//   { name: 'Partner 1', logo: 'union.svg' },
//   { name: 'Partner 2', logo: 'masterc.svg' },
//   { name: 'Partner 3', logo: 'bob.svg' },
//   { name: 'Partner 4', logo: 'mswc.svg' },
//   { name: 'Partner 5', logo: 'wb.svg' },
//   { name: 'Partner 6', logo: 'tvs.svg' },
//   { name: 'Partner 7', logo: 'msc.svg' },
// ];

// const PartnersComponent = () => {
//   const scrollingPartners = [...partners, ...partners]; // Duplicate for loop

//   return (
//     <section className="py-10 px-5 bg-white overflow-hidden">
//       <div className="relative w-full">
//         <div className="animate-marquee flex w-max gap-16">
//           {scrollingPartners.map((partner, index) => (
//             <div key={index} className="flex justify-center items-center">
//               <img
//                 src={partner.logo}
//                 alt={partner.name}
//                 width={180}
//                 height={80}
//                 style={{ objectFit: 'contain' }}
//               />
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

export default PartnersComponent;
